// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__27Cvb","container":"styles_container__1klC3","title":"styles_title__2l_lr","wrapper":"styles_wrapper__2h4pE","answer":"styles_answer__1y-bT"};